import React, { useEffect, useState } from "react";
import { useValidate } from "hooks/useValidate";
import ModalPortal from "components-new/ModalPortal";
import sass from "pages/References/BusinessProcessRegistry/register.module.sass";
import InputTemp from "components-new/InputTemp";
import TextArea from "components-new/Textarea";
import { Button } from "components/shared";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "components/shared/Button/Button";
import { ReactComponent as FileIcon } from "images/FileV3.svg";
import { snackWrapper } from "helpers";
import { organizationAPI } from "libs/apiClient/Organization";

const initial: ICreateBusinessTemplate = {
	name: "",
	comment: "",
};
export const Modal: React.FC<{
	rootFunc: () => void;
	trigger: { active: boolean; data: ICreateBusinessTemplate | null; loadTemplate?: boolean };
	cancelWindow: () => void;
}> = ({ trigger, cancelWindow, rootFunc }) => {
	const [newType, setNewType] = useState<ICreateBusinessTemplate>(initial);

	useEffect(() => {
		if (trigger.data) {
			setNewType(trigger.data);
		} else {
			setNewType(initial);
		}
		//eslint-disable-next-line
	}, [trigger.active]);
	const [errors, setErrors] = useState(false);

	const setError = () => {
		setErrors(true);
		setTimeout(() => {
			setErrors(false);
		}, 3000);
	};
	const send = () => {
		if (!trigger.data) {
			organizationAPI
				.processesPatternCreate({ ...newType, bpIdsList: [] }, ",")
				.then(() => {
					snackWrapper("success", "Запись успешно создана");
					rootFunc();
					cancelWindow();
				})
				.catch(() => {
					setError();
				});
		} else {
			const { id, ...rest } = newType;
			organizationAPI
				.processesPatternEditCreditCreate(id!, { ...rest })
				.then(() => {
					snackWrapper("success", "Запись успешно отредактирована");
					rootFunc();
					cancelWindow();
				})
				.catch(() => {
					setError();
				});
		}
	};

	const { validate } = useValidate(newType, ["name"], send);

	const changeField = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		let { name, value } = e.target;
		if (/^\s/.test(value)) value = value.replace(/^\s/, "");
		setNewType((prevState) => ({ ...prevState, [name]: value }));
	};

	const [file, setFile] = useState<File>();

	const selectFile = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.files && e.target.files.length) {
			const file = new FormData();
			file.append("file", e.target.files[0]);
			setFile(e.target.files[0]);
			// send(file)
			// setFile(file)
			// setModal(true)
		} else {
			// close()
		}
	};

	return trigger.active ? (
		<ModalPortal
			outSide={false}
			title={
				trigger.loadTemplate
					? "Загрузить шаблон реестра бизнес-процессов"
					: trigger.data
					? "Редактирование шаблона реестра бизнес-процессов"
					: "Создание шаблона реестра бизнес-процессов"
			}
			handleClose={cancelWindow}>
			<div className={sass.modal}>
				<InputTemp
					placeholder={"Введите текст"}
					value={newType.name}
					errorText={errors ? "Такое имя существует" : ""}
					name={"name"}
					onChange={changeField}
					label={"Название"}
					required
				/>
				{/*<InputTemp type={"select"} onChange={()=>{}} field={'name'} options={[{id:1,name:'Социальная'},{id:2,name:'Культурная'}]}*/}
				{/*           placeholder={'Не выбрано'} label={'Организация'} required/>*/}
				<TextArea
					rows={2}
					placeholder={"Введите текст"}
					value={newType.comment}
					name={"comment"}
					onChange={changeField}
					label={"Комментарий"}
				/>
				{/*<InputTemp errorText={errors.name} onChange={changeField} error={error && !newType.name} name={'name'} value={newType.name}*/}
				{/*           placeholder={'Введите текст'} label={'Статус'} required/>*/}
				{trigger.loadTemplate && (
					<div className={sass.fileAdd}>
						{file ? (
							<>
								<p className={sass.filename}>
									<FileIcon /> <span>{file.name}</span>
								</p>
								<label className={sass.file}>
									Изменить
									<input onChange={selectFile} type={"file"} hidden={true} />
								</label>
							</>
						) : (
							<>
								<span />
								<label className={sass.file}>
									Прикрепить документ
									<input onChange={selectFile} type={"file"} hidden={true} />
								</label>
							</>
						)}
						{/*<label className={sass.file}>Прикрепить документ<input onChange={selectFile} type={'file'} hidden={true}/></label>*/}
						{/*<span>Изменить</span>*/}
					</div>
				)}
				<div className={sass.btns}>
					<Button onClick={cancelWindow} variant={BUTTON_VARIANTS.OUTLINED}>
						Отменить
					</Button>
					<Button onClick={validate}>Готово</Button>
				</div>
			</div>
		</ModalPortal>
	) : null;
};

export interface ICreateBusinessTemplate {
	id?: number;
	name: string;
	comment: string;
}

export const ConfirmArchiveTemplate: React.FC<{ cancelWindow: () => void; remove: () => void }> = ({
	cancelWindow,
	remove,
}) => {
	return (
		<ModalPortal className={sass.modalWrapper} outSide={false} title={"Вы уверены?"} handleClose={cancelWindow}>
			<div className={sass.modal}>
				<p className={sass.confirm}>
					В архив переместится шаблон и <span style={{ fontWeight: 700 }}>всё его содержимое</span>
				</p>
				<div className={sass.btns}>
					<Button onClick={cancelWindow} variant={BUTTON_VARIANTS.OUTLINED}>
						Отменить
					</Button>
					<Button color={BUTTON_COLORS.ERROR} onClick={remove}>
						Архивировать
					</Button>
				</div>
			</div>
		</ModalPortal>
	);
};

export const ConfirmModal: React.FC<any> = ({ close, ok, redirect }) => {
	const [select, setSelect] = useState<{ id: number; name: string } | null>(null);

	return (
		<ModalPortal
			className={sass.modalWrapperConfirm}
			handleClose={close}
			outSide={false}
			title={"Подключение шаблона реестра БП"}>
			<div className={sass.modal}>
				<p className={sass.confirm}>Выберите способ подключения шаблона</p>
				<InputTemp
					label={"Тип подключения"}
					required={true}
					placeholder={"Не выбрано"}
					field={"name"}
					value={select ? select.name : ""}
					onSelect={(e) => {
						setSelect(e);
					}}
					type={"select"}
					options={[
						{ id: 1, name: "Подключить целиком" },
						{ id: 2, name: "Выбрать бизнес-процессы" },
					]}
				/>
				<div className={sass.btns}>
					<Button variant={BUTTON_VARIANTS.OUTLINED} onClick={close}>
						Отменить
					</Button>
					<Button
						disabled={!select}
						onClick={() => {
							select && select.id === 2 ? ok() : redirect();
							close();
						}}>
						Готово
					</Button>
				</div>
			</div>
		</ModalPortal>
	);
};
